module.exports = __webpack_public_path__ + "img/bankcard.d6346ef3.svg";